import { EMPTY_LIST } from '../../../../constants/common'

function mapGretaAIChatProjectSubject(subject) {
  return subject
    ? {
        building: {
          address: subject.building.address,
          hasAccess: subject.building.has_access,
          id: subject.building.id,
          number: subject.building.number,
        },
        requests: subject.requests,
        type: subject.type,
      }
    : null
}

function mapGretaAIChatProject(project) {
  return {
    chatIds: project.conversation_ids,
    id: project.id,
    lastActivityAt: new Date(project.last_activity).getTime(),
    name: project.name,
    subject: mapGretaAIChatProjectSubject(project.subject),
  }
}

export function getGretaAIChatProjectsWithChats(projects, chats) {
  const chatById = new Map(chats.map(chat => [chat.id, chat]))

  return projects.map(project => ({
    ...project,
    chats: project.chatIds
      .filter(chatId => chatById.has(chatId))
      .map(chatId => chatById.get(chatId)),
  }))
}

export function mapGretaAIChatProjects(response) {
  return (response?.data?.results ?? EMPTY_LIST).map(mapGretaAIChatProject)
}
